// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-container {
  padding: 4px 0;
}

.detail-section {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}
.detail-section:last-child {
  border-bottom: none;
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  margin-bottom: 10px;
}

.section-header {
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding-bottom: 4px;
  border-bottom: 2px solid #1976d2;
}

.row {
  margin-bottom: 4px;
  align-items: baseline;
}

textarea {
  font-size: 0.875rem;
  resize: vertical;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 2px;
  padding: 4px 6px;
}

.empty-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  font-style: italic;
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/inventory/inventory-dialog/material-detail/material-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAAF","sourcesContent":[".detail-container {\n  padding: 4px 0;\n}\n\n.detail-section {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e0e0e0;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.section-header {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n  padding-bottom: 4px;\n  border-bottom: 2px solid #1976d2;\n}\n\n.row {\n  margin-bottom: 4px;\n  align-items: baseline;\n}\n\ntextarea {\n  font-size: 0.875rem;\n  resize: vertical;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 2px;\n  padding: 4px 6px;\n}\n\n.empty-detail {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #999;\n  font-style: italic;\n  font-size: 0.875rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
